// src/components/Blog/AdminBlogManager.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api"; // adjust path if needed

const AdminBlogManager = () => {
  const [pending, setPending] = useState([]);
  const [approved, setApproved] = useState([]);
  const [tab, setTab] = useState("pending");
  const navigate = useNavigate();
  const baseURL= process.env.REACT_APP_BASE_URL+"uploads";
  
  useEffect(() => {
    fetchLists();
  }, []);
const fetchLists = async () => {
  try {
    const [pendingRes, approvedRes] = await Promise.all([
      api.get("/api/blogs/pending"),
      api.get("/api/blogs/approved"),
    ]);

    setPending(pendingRes.data);
    setApproved(approvedRes.data);
  } catch (err) {
    console.error(err);
    setPending([]);
    setApproved([]);
  }
};

const approve = async (id) => {
  try {
    await api.put(`/api/blogs/${id}/approve`);
    fetchLists();
  } catch (err) {
    console.error(err);
    alert("Approve failed");
  }
};


const del = async (id) => {
  if (!window.confirm("Delete this blog?")) return;

  try {
    await api.delete(`/api/blogs/${id}`);
    fetchLists();
  } catch (err) {
    console.error(err);
    alert("Delete failed");
  }
};

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold">Admin — Blog Manager</h3>
        <div>
          <button
            onClick={() => navigate("add")}
            className="bg-green-500 text-white px-3 py-1 rounded mr-2"
          >
            Add Blog
          </button>
        </div>
      </div>

      <div className="flex gap-2 mb-4">
        <button
          className={`px-4 py-2 rounded ${
            tab === "pending" ? "bg-blue-600 text-white" : "bg-gray-200"
          }`}
          onClick={() => setTab("pending")}
        >
          Pending ({pending.length})
        </button>
        <button
          className={`px-4 py-2 rounded ${
            tab === "approved" ? "bg-blue-600 text-white" : "bg-gray-200"
          }`}
          onClick={() => setTab("approved")}
        >
          Approved ({approved.length})
        </button>
      </div>

      {tab === "pending" && (
        <div>
          {pending.length === 0 ? (
            <p className="text-gray-500">No pending blogs.</p>
          ) : (
            <div className="space-y-3">
              {pending.map((b) => (
                <div
                  key={b.id}
                  className="border p-3 rounded flex justify-between items-start"
                >
                  <div>
                    <h4 className="font-bold">{b.title}</h4>
                    <p className="text-sm text-gray-600">
                      {b.textContent?.slice(0, 140)}
                    </p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <button
                      className="px-3 py-1 bg-green-600 text-white rounded"
                      onClick={() => approve(b.id)}
                    >
                      Approve
                    </button>
                    <button
                      className="px-3 py-1 bg-yellow-500 text-white rounded"
                      onClick={() => navigate(`/admin/blog/edit/${b.id}`)}
                    >
                      Edit (create new)
                    </button>
                    <button
                      className="px-3 py-1 bg-red-500 text-white rounded"
                      onClick={() => del(b.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {tab === "approved" && (
        <div>
          {approved.length === 0 ? (
            <p className="text-gray-500">No approved blogs.</p>
          ) : (
            <div className="grid md:grid-cols-2 gap-3">
              {approved.map((b) => (
                <div key={b.id} className="border p-3 rounded bg-white">
                  {b.imageFileName && (
                    <img
                      src={`${baseURL}/${b.imageFileName}`}
                      alt={b.title}
                      className="w-full h-36 object-cover rounded mb-2"
                    />
                  )}
                  <h4 className="font-bold">{b.title}</h4>
                  <p className="text-sm text-gray-600">
                    {b.textContent?.slice(0, 140)}
                  </p>
                  <div className="mt-2 flex gap-2">
                    <button
                      className="px-3 py-1 bg-yellow-500 text-white rounded"
                      onClick={() => navigate(`/admin/blog/edit/${b.id}`)}
                    >
                      Edit
                    </button>
                    <button
                      className="px-3 py-1 bg-red-500 text-white rounded"
                      onClick={() => del(b.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminBlogManager;
